/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Snippet_TerminalInputs */

const en_mcp_snippet_terminal = /** @type {(inputs: Mcp_Snippet_TerminalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminal`)
};

const es_mcp_snippet_terminal = /** @type {(inputs: Mcp_Snippet_TerminalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminal`)
};

/**
* | output |
* | --- |
* | "Terminal" |
*
* @param {Mcp_Snippet_TerminalInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_snippet_terminal = /** @type {((inputs?: Mcp_Snippet_TerminalInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Snippet_TerminalInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_snippet_terminal(inputs)
	return en_mcp_snippet_terminal(inputs)
});